import clsx from 'clsx';

import useTitle from 'hooks/useTitle';
import { styled } from 'netline-ui';

import styles, { appHeaderTitleClasses, appHeaderTitleRootClasses } from './AppHeaderTitle.styles';

const AppHeaderTitleRoot = styled('div', { name: appHeaderTitleClasses.$name })(styles);

const AppHeaderTitle = () => {
  const { title, titleSvgUrl, titleSvgTooltip } = useTitle();

  if (titleSvgUrl) {
    return (
      <AppHeaderTitleRoot data-testid="AppHeaderTitle-root" className={appHeaderTitleClasses.root}>
        <div className="AppHeaderTitle-svgContainer">
          <img
            src={titleSvgUrl}
            alt={titleSvgTooltip ?? title}
            title={titleSvgTooltip ?? title}
            className="AppHeaderTitle-titleSvg"
          />
        </div>
      </AppHeaderTitleRoot>
    );
  }

  return (
    <AppHeaderTitleRoot className={clsx(appHeaderTitleClasses.root, appHeaderTitleRootClasses.simple)}>
      <span data-testid="AppHeaderTitle-root" className="AppHeaderTitle-title">
        {title}
      </span>
    </AppHeaderTitleRoot>
  );
};

export default AppHeaderTitle;
